import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from 'react-router';
import { Box } from '@mui/material';
import { DelayedLoadIndicator } from '../delayed-load-indicator';
import { ManageExtensionCard } from '../extension/manage-extension-card';
import { ExtensionGrid } from '../page-primitives';
import { EmptyPlaceholder, SettingsSectionTitle } from '../../pages/user/settings/settings-primitives';
import { useNamespaceExtensionList } from './use-namespace-extension-list';
export const NamespaceExtensionList = props => {
    // The card links back to wherever the namespace is being viewed, user settings or admin alike.
    const { pathname } = useLocation();
    const { extensions, isPending: loading } = useNamespaceExtensionList(props.namespace, {
        extensionQuery: props.extensionQuery,
        omitUnavailable: props.omitUnavailable
    });
    return (_jsxs(Box, { children: [_jsx(SettingsSectionTitle, { component: 'h3', children: "Extensions" }), _jsx(DelayedLoadIndicator, { loading: loading }), loading ? null : extensions.length > 0 ? (_jsx(ExtensionGrid, { children: extensions.map(extension => (_jsx(ManageExtensionCard, { extension: extension, routePrefix: props.routePrefix, linkState: {
                        backTo: pathname,
                        backLabel: `Back to ${props.namespace.name}`
                    } }, `${extension.namespace}.${extension.name}-${extension.version}`))) })) : (_jsx(EmptyPlaceholder, { children: "No extensions published under this namespace yet." }))] }));
};
//# sourceMappingURL=namespace-extension-list.js.map